import React from 'react';

import { FormTooltip } from 'app/components/FormTooltip';
import { VinNumberReadonlyControlProps } from './VinNumberReadonlyControl.interfaces';
import { useStyles } from './VinNumberReadonlyControl.styles';

export default function VinNumberReadonlyControl({
  input: { value: inputValue },
  label,
  tooltip,
}: VinNumberReadonlyControlProps) {
  const classes = useStyles();

  return inputValue ? (
    <div>
      <div className={classes.labelWrapper}>
        <div className={classes.label}>{label}</div>
        <FormTooltip content={tooltip} className={classes.tooltip} />
      </div>
      <div className={classes.value}>{inputValue}</div>
    </div>
  ) : null;
}
